import { Box, IconButton, Typography } from "@mui/material";
import { useState, useEffect } from "react";
import Cookies from "js-cookie";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import SiteList from "../../components/siteselector/SiteList";
import GetSites from "../../components/api/GetSites";
import { useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import GetUser from "../../components/api/GetUser";
import UserPopup from "../../components/userpopup";
import LoginCookieAuth from "../../components/api/LoginCookieAuth";

const Topbar = ({ showSiteList, headerTitle, headerSubtitle }) => {
  if (showSiteList == null) showSiteList = true;
  const [siteData, setSiteData] = useState([]);
  const navigate = useNavigate();
  const [userData, setUserData] = useState([]);
  const [popupOpen, setPopupOpen] = useState(false)
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 970);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 970);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    LoginCookieAuth(Cookies.get('skyarc-auth-8080')).then(async(authResponse) => {
      if(authResponse) {
        GetSites().then((response) => {
          if (response.length === 0) {
            setSiteData([]);
          } else {
            const responseData = response.data;
            const responseVal = responseData["rows"];
            setSiteData(<SiteList dataValues={responseVal} />);
          }
        });
        GetUser().then((response) => {
          if (response.data !== null) setUserData(response.data["rows"][0]);
        });
      }
    })
  }, []);

  return (
    <Box sx={{ display: "flex", width: "100%" }} p={2}>
      {/* ICONS */}
      <Box sx={{ display: "flex", justifyContent: "flex-start", width: "30%" }}>
        <Header title={headerTitle} subtitle={headerSubtitle} />
      </Box>
      <Box sx={{ display: "flex", justifyContent: "flex-end", width: "70%" }}>
        {showSiteList ? (
          <Box sx={{ display: "flex", alignItems: "center", marginRight:'8px' }}>{siteData}</Box>
        ) : (
          <></>
        )}
        <Box sx={{display:'flex', alignItems:'center', cursor:'pointer'}} onClick={() => setPopupOpen(true)}>
          {isSmallScreen ? <></> : <Typography sx={{fontWeight: "bold", color:'gray' }}>{userData.dis}</Typography>}
          <IconButton onClick={() => setPopupOpen(true)} aria-label="Navigate to userpage">
            <PersonOutlinedIcon />
          </IconButton>
          <UserPopup open={popupOpen} onClose={() => setPopupOpen(false)} userData={userData}/>
        </Box>
        <Box sx={{display:'flex', alignItems:'center',}}>
        <IconButton
          onClick={() => {
            Cookies.remove("skyarc-auth-8080");
            navigate("/");
          }}
          aria-label="Logout"
        >
          <ExitToAppIcon />
        </IconButton>
        </Box>
      </Box>
    </Box>
  );
};

export default Topbar;
